// extracted by mini-css-extract-plugin
export default {"business_name":"businessName_business_name__iP2Ob","confirmation":"businessName_confirmation__xqALD"};